import React from "react";
import { Grid, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductCard from "./ProductCard";

const RelatedProducts = (props) => {
  return (
    <section className="flat-spacing-1 pt_0">
      <div className="container">
        <div className="flat-title">
          <span className="title">You may also like</span>
        </div>
        <div className="hover-sw-nav hover-sw-2">
          <Swiper
            slidesPerView={4}
            grid={{
              rows: 1,
            }}
            spaceBetween={30}
            navigation={true}
            modules={[Grid, Navigation]}
            className="swiper tf-sw-product-sell wrap-sw-over"
          >
            {props.data.map((prod, index) => (
              <SwiperSlide key={index}>
                <ProductCard {...prod} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
